export function cleanCreatedTimestamp(created) {
  if (!created || typeof created !== "string") return "";
  // Handles formats like "2025-01-06T03:43:47.677Z-u38k53"
  const lastDashIndex = created.lastIndexOf("-");
  return lastDashIndex > 10 ? created.substring(0, lastDashIndex) : created;
}

export function getCreatedDate(created) {
  const cleaned = cleanCreatedTimestamp(created);
  if (!cleaned) return null;
  const d = new Date(cleaned);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function getCreatedTimeMsFromCreated(created) {
  const d = getCreatedDate(created);
  return d ? d.getTime() : 0;
}

